module.exports = __webpack_public_path__ + "static/media/hotspot_body_2.b8ba5a56.png";